import React, { useRef } from 'react';
import { Text, Image, IconButton, BoxProps, Flex } from '@chakra-ui/react';
import AudioIcon from '../../../../../../components/icons/Audio';
import { Content } from './types';
import { mapAlign } from '../CardFlip';

type ContentComponentProps = Content & BoxProps;

export const ContentComponent: React.FC<ContentComponentProps> = (c) => {
  const {
    type,
    align = 'justify',
    textAlign = 'center',
    justify,
    src,
    alt_text,
    whiteSpace = 'normal',
    wordBreak = 'break-word',
    ...rest
  } = c;
  const audio = useRef<HTMLAudioElement>();
  let content = null;
  switch (type) {
    case 'text':
      content = (
        <Flex justify={mapAlign(align)} {...rest}>
          <Text
            as="div"
            textAlign={textAlign}
            maxWidth="100%"
            wordBreak={wordBreak}
            whiteSpace={whiteSpace}
          >
            {src}
          </Text>
        </Flex>
      );
      break;
    case 'image':
      content = (
        <Flex justify={mapAlign(align)} {...rest}>
          <Image src={src} alt={alt_text ?? ''} />
        </Flex>
      );
      break;
    case 'audio':
      content = (
        <Flex justify={mapAlign(align)} {...rest}>
          <IconButton
            aria-label="Play sound"
            colorScheme="stemiBlue"
            variant="outline"
            borderRadius="100%"
            icon={<AudioIcon boxSize="16px" />}
            onClick={() => {
              if (audio.current) {
                if (audio.current.paused) audio.current.play();
                else audio.current.pause();
              }
            }}
          />
          {/* @ts-ignore */}
          <audio src={src} ref={audio}>
            Your browser does not support the audio element.
          </audio>
        </Flex>
      );
      break;
  }

  return content;
};
